import { Link } from "react-router-dom";
import { CONTACT_EMAIL } from "@/services/inquiry";
import { site } from "../content/site";
import { useContent, Rich } from "../ui/helpers";
import { Logo } from "./SiteHeader";

/*
  FOOTER — text and links: src/site/content/site.js (footer)
           e-mail address: src/services/inquiry.js (CONTACT_EMAIL)
           styles: src/site/site.css, section "Footer"
*/
const href = (l) => (l.hash ? `${l.to}#${l.hash}` : l.to);

export function SiteFooter() {
  const c = useContent(site);
  const f = c.footer;
  return (
    <div className="kss-v2">
      <footer className="ftr" data-testid="site-footer">
        <div className="k-wrap">
          <div className="ftr-grid">
            <div className="ftr-brand">
              <Link to="/" aria-label={c.homeLabel} className="brand ftr-logo">
                <Logo />
              </Link>
              <p><Rich text={f.description} /></p>
            </div>

            {f.cols.map((col) => (
              <nav key={col.title} className="ftr-col" aria-label={col.title}>
                <h2>{col.title}</h2>
                <ul>{col.links.map((l) => <li key={l.label}><Link to={href(l)}>{l.label}</Link></li>)}</ul>
              </nav>
            ))}

            <div className="ftr-col ftr-contact">
              <h2>{f.contactTitle}</h2>
              <p>{f.contactText}</p>
              <a className="ftr-mail" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
              <Link className="ftr-inquiry" to="/contact">{f.inquiry}</Link>
            </div>
          </div>

          <div className="ftr-base">
            <span>{f.rights}</span>
            <Link to="/privacy">{f.privacy}</Link>
            <span className="ftr-domain">{f.domain}</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
